import { Link } from "react-router-dom";
import { Wordmark } from "./Navbar";
import { SITE } from "@/config/site";

const EXPLORE = [
  { to: "/patients-families", label: "Patients & Families" },
  { to: "/professionals", label: "Healthcare Professionals" },
  { to: "/about", label: "About Homevia" },
  { to: "/services", label: "Services" },
];

const START = [
  { to: "/request-care", label: "Request Care" },
  { to: "/referral", label: "Submit a Referral" },
  { to: "/consultation", label: "Schedule a Consultation" },
  { to: "/careers", label: "Careers" },
  { to: "/contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="grain bg-olive text-cream/90">
      <div className="relative z-[2] mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-24">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Wordmark dark />
            <p className="mt-6 max-w-sm font-serif text-2xl leading-snug text-cream/85">
              The space between hospital and home, held with care.
            </p>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-cream/60">
              {SITE.address}
            </p>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-cream/60">
              <a href={SITE.phoneHref} data-testid="footer-phone-link" className="transition-colors hover:text-cream">
                {SITE.phone}
              </a>
              <span className="mx-2">·</span>
              <a href={`mailto:${SITE.email}`} data-testid="footer-email-link" className="break-all transition-colors hover:text-cream">
                {SITE.email}
              </a>
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-sage">Explore</p>
            <ul className="mt-5 space-y-3">
              {EXPLORE.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    className="text-sm text-cream/75 transition-colors duration-300 hover:text-cream"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-sage">Start here</p>
            <ul className="mt-5 space-y-3">
              {START.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-cta-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    className="text-sm text-cream/75 transition-colors duration-300 hover:text-cream"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-16 flex flex-col gap-4 border-t border-cream/15 pt-8 text-xs text-cream/50 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Homevia Transitional Care. All rights reserved.</p>
          <p>The content on this website is informational and is not medical advice.</p>
          <Link to="/admin/login" data-testid="footer-admin-link" className="transition-colors hover:text-cream">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
